import { Flex } from '@televet/kibble-ui/build/chakra';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React, { forwardRef } from 'react';

// ref is not used, but it's needed to forward the ref to the underlying div
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const AttachmentsSubmenu = forwardRef<HTMLDivElement, 'div'>((props, _ref) => {
  return (
    <Flex justifyContent="space-between" alignItems="center" data-testid="attach-forms-button" {...props} m={0} p={0}>
      <Flex>
        <Icon name="form" mr={3} />
        <Text size="sm">Forms</Text>
      </Flex>
      <Icon size="sm" name="chevronRight" />
    </Flex>
  );
});

AttachmentsSubmenu.displayName = 'ProviderSubMenu';
